import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StorageComponent } from './storage.component';
import { StorageFormComponent } from './storage-form/storage-form.component';

const routes: Routes = [{
  path: '', component: StorageComponent, children: [{
path: 'form', component: StorageFormComponent
  }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StorageRoutingModule { }
